(function () {
  class FrameArrowsAnimsView extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      this.wobbleTween;
      this.allSymbolsArray = [];
      this.chosenSyms = [];
      this._positions;
      this.arrows = {};
      StateMachine.Create(this); //could add states for left and right wins?
    }

    initialise() {
      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      var numOfArrows = 9;
      var leftArrowArray = [];
      var rightArrowArray = [];
      let yDistance = 0;

      for (let arrowID = 0; arrowID < numOfArrows; arrowID++) {
        let leftArrow = resourceManager.createObject(
          "sprite",
          `arrowLeft${arrowID}`,
          "frameArrowsAnimsView:left",
          {
            fileName: "Border_Arrows/Border_Arrow.png",
            anchor: 0.5,
            y: yDistance,
          }
        );
        let leftArrowAnimation = resourceManager.createObject(
          "movie",
          `arrowAnimLeft${arrowID}`,
          "frameArrowsAnimsView:left",
          { definition: "ArrowSpark", loop: false, anchor: 0.5, y: yDistance }
        );
        let rightArrow = resourceManager.createObject(
          "sprite",
          `arrowRight${arrowID}`,
          "frameArrowsAnimsView:right",
          {
            fileName: "Border_Arrows/Border_Arrow.png",
            anchor: 0.5,
            y: yDistance,
            scaleX: -1,
          }
        );
        let rightArrowAnimation = resourceManager.createObject(
          "movie",
          `arrowAnimRight${arrowID}`,
          "frameArrowsAnimsView:right",
          {
            definition: "ArrowSpark",
            loop: false,
            anchor: 0.5,
            y: yDistance,
            scaleX: -1,
          }
        );

        leftArrow.visible = false;
        leftArrowAnimation.stop();
        rightArrow.visible = false;
        rightArrowAnimation.stop();

        if (arrowID === 2 || arrowID === 5) {
          yDistance += 110; // for the gap
        } else {
          yDistance += 60; // distance between arrows
        }

        leftArrowArray.push({ sprite: leftArrow, anim: leftArrowAnimation });
        rightArrowArray.push({ sprite: rightArrow, anim: rightArrowAnimation });

        this.arrows = {
          left: leftArrowArray,
          right: rightArrowArray,
        };
      }
    }

    showArrows(arrowType, cb) {
      let self = this;
      for (
        let arrowIdx = 0;
        arrowIdx < this.arrows[arrowType].length;
        arrowIdx++
      ) {
        this.arrows[arrowType][arrowIdx].sprite.visible = true;
        if (arrowIdx === this.arrows[arrowType].length - 1) {
          this.arrows[arrowType][arrowIdx].anim.onComplete = function () {
            self.hideArrows(arrowType);
            if (cb) cb();
          };
        }
        this.arrows[arrowType][arrowIdx].anim.gotoAndPlay(0);
      }
    }

    hideArrows(arrowType) {
      for (
        let arrowIdx = 0;
        arrowIdx < this.arrows[arrowType].length;
        arrowIdx++
      ) {
        this.arrows[arrowType][arrowIdx].sprite.visible = false;
      }
    }

    getSourcePos() {
      return this._sourcePos;
    }
  }

  create = function (json) {
    return new FrameArrowsAnimsView();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType(
    "frameArrowsAnimsView",
    create,
    initialise,
    getFilesRequired
  );
})();
